import * as React from 'react';
// eslint-disable-next-line no-restricted-imports
import { Switch as DSSwitch } from '@hvcgroep/design-system';
import { Props as DSSwichProps } from '@hvcgroep/design-system/dist/components/Switch';

import { APP_ID } from '../../config/constants';
import gtm from '../../helpers/gtm';

const Switch: React.FC<DSSwichProps> = (props) => {
  const {
    onChange,
  } = props;

  return (
    <DSSwitch
      {...props}
      onChange={(key) => {
        onChange(key);
        gtm.trackUserEvent(String(APP_ID), 'Switch change', key);
      }}
    />
  );
};

export default Switch;
